import React from "react";
import { Button, Progress, Label } from "semantic-ui-react";
import "./Paso5Checklist.scss";

const AUTO_LABEL = { ok: "cumple", no: "no cumple", pe: "pendiente", na: "n/a" };
const AUTO_COLOR = { ok: "green", no: "red", pe: "yellow", na: "grey" };
const BUTTONS = [
  { value: "ok", label: "Cumple", cls: "on-ok" },
  { value: "no", label: "No", cls: "on-no" },
  { value: "pe", label: "Pend.", cls: "on-pe" },
  { value: "na", label: "N/A", cls: "on-na" },
];

// Portado de vP5() del prototipo (línea 868) — 23 criterios (c_org…c_rec),
// leídos de computed.criteria (server/services/sbtiEngine.criteriaChecklist,
// SBTI-008): un solo lugar de verdad para el texto y la autoevaluación.
export function Paso5Checklist({ record, computed, patchSection }) {
  const criteria = record.criteria || {};
  const list = computed?.criteria || [];
  const items = list.filter((x) => !x.group);
  const done = items.filter((x) => ["ok", "na"].includes(criteria[x.id]?.status)).length;
  const pct = items.length ? Math.round((done / items.length) * 100) : 0;

  const setCrit = (id, value) => {
    patchSection(
      "criteria",
      { ...criteria, [id]: { status: value, autoValue: criteria[id]?.autoValue ?? null, autoMessage: criteria[id]?.autoMessage ?? null, updatedOn: new Date().toISOString() } },
      { immediate: true }
    );
  };

  const applyAuto = () => {
    const next = { ...criteria };
    let n = 0;
    items.forEach((it) => {
      if (it.auto && it.auto.value) {
        next[it.id] = { status: it.auto.value, autoValue: it.auto.value, autoMessage: it.auto.message, updatedOn: new Date().toISOString() };
        n++;
      }
    });
    patchSection("criteria", next, { immediate: true });
    return n;
  };

  let currentGroup = null;

  return (
    <div className="sbti-paso5">
      <div className="sbti-pagehead">
        <div className="sbti-crumb">Paso 5 · Control de conformidad</div>
        <h2>Autochequeo de criterios <span className="sbti-pgram"><span>V5.3.1</span></span> antes de presentar</h2>
        <p className="sbti-sub">
          Checklist interno contra los Criterios Near-Term vigentes y la guía sectorial. Donde el módulo tiene
          datos, propone una autoevaluación con su justificación; la decisión final la marca el equipo.
        </p>
      </div>

      <div className="sbti-card">
        <div className="sbti-paso5__progress">
          <Progress percent={pct} size="small" className="sbti-paso5__bar" />
          <Label color={pct === 100 ? "green" : "blue"}>{done}/{items.length} conformes o N/A · {pct}%</Label>
          <Button size="small" onClick={applyAuto}>Aplicar autoevaluación disponible</Button>
        </div>
      </div>

      {list.map((it, ix) => {
        if (it.group) {
          currentGroup = it.group;
          return (
            <div className="sbti-card sbti-paso5__group-head" key={`g-${ix}`}>
              <h3><span className="sbti-tag">GRUPO</span> {currentGroup}</h3>
            </div>
          );
        }
        const status = criteria[it.id]?.status || "";
        return (
          <div className="sbti-crit" key={it.id}>
            <div className="sbti-crit__id">{it.ref ? `[${it.ref}]` : "—"}</div>
            <div className="sbti-crit__body">
              <div className="sbti-crit__title">{it.title}</div>
              <div className="sbti-crit__desc">{it.description}</div>
              {it.auto && (
                <div className="sbti-crit__auto">
                  <Label size="tiny" color={AUTO_COLOR[it.auto.value]}>auto: {AUTO_LABEL[it.auto.value]}</Label>
                  <span className="sbti-crit__auto-msg">{it.auto.message}</span>
                </div>
              )}
            </div>
            <div className="sbti-seg">
              {BUTTONS.map((b) => (
                <button
                  key={b.value}
                  type="button"
                  className={status === b.value ? b.cls : ""}
                  onClick={() => setCrit(it.id, b.value)}
                >
                  {b.label}
                </button>
              ))}
            </div>
          </div>
        );
      })}

      <div className="sbti-card">
        <div className="sbti-src">
          <b>Fuentes:</b> SBTi Corporate Near-Term Criteria V5.3.1; Criteria Assessment Indicators v1.7 — de donde
          se toman las referencias NT C1, NT C6, NT C13, NT C27 y C28 verificadas; guía sectorial 2019 §3–§6; Guía
          FLAG; guía de revisiones quinquenales. El módulo no reemplaza la evaluación oficial del equipo de
          validación del SBTi.
        </div>
      </div>
    </div>
  );
}
